import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String, frame: String }

  connect() {
    // 提示该行可以交互，但不要影响行内按钮的体感
    // 只有在非交互元素上才显示 pointer
    this.element.classList.add("cursor-default")
  }

  edit(event) {
    // 1. 核心改进：排除行内交互元素（按钮、链接、输入框、复制按钮等）
    // 确保点击这些东西时不会触发双击编辑
    if (event.target.closest("a, button, input, select, [data-action*='copy']")) return

    // 2. 核心改进：处理双击导致自动选中文本的问题
    // 用户双击时浏览器通常会选中文字，之前的逻辑 length > 0 就 return 导致了“不灵敏”
    // 我们应该允许双击，但要在执行前清除掉这些意外选中的文字
    const selection = window.getSelection()
    
    // 如果用户是故意“拖拽”选中了大段文字（比如超过 10 个字符），我们认为他是想看文字，不触发编辑
    if (selection.toString().length > 20) return

    // 清除选区，让 UI 保持整洁
    selection.removeAllRanges()

    // 3. 执行跳转或加载 Frame
    if (this.frameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        // 增加一个简单的加载反馈体感（可选）
        this.element.style.opacity = "0.7"
        frame.src = this.urlValue
        
        // 监听 Frame 加载完成还原透明度
        frame.addEventListener("turbo:frame-load", () => {
          this.element.style.opacity = "1"
        }, { once: true })
      }
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
